import {RootState} from "../../../store";

export const getSnackbarNotification = (state: RootState) => state.snackbarReducer.notifications;
export const getSnackbarErrors = (state: RootState) => state.snackbarReducer.errors;
export const getSnackbarPrivateMessage = (state: RootState) => state.snackbarReducer.notificationPrivateMessage;
export const getSnackbarInfoMessages = (state: RootState) => state.snackbarReducer.infoMessages;
